function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import Cookies from 'js-cookie';
import CheckSizeMixin from '../../../assets/scripts/mixins/check-size-mixin';

var GeoLocalization = /*#__PURE__*/function () {
  function GeoLocalization() {
    _classCallCheck(this, GeoLocalization);
  }

  _createClass(GeoLocalization, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-geo-localization', {
        template: "\n      <div class=\"geo-localization\" :class=\"classes\">\n        <div class=\"language\" v-if=\"$slots.language\">\n          <slot name=\"language\" />\n        </div>\n        <button @click.prevent=\"togglePanel\" class=\"geo-localisation--button\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" xml:space=\"preserve\" version=\"1.1\" viewBox=\"0 0 24 24\">\n            <path\n              d=\"m15.4 21.6-1.3-.6-.5-1v-.5l-.5-1V18l-1.1-.6h-1.6l-1-.5-.5-1.6v-1.6l1-1.1 1-.5h1.6l.5.5.5.5h.5l.5-.5h1.6v.5l1 2.1 1.6.5v.5l-1 1-.5.5v1l-1 1v1.4m2.6-1.3v-1.4\"\n              fill=\"none\" stroke=\"currentColor\" />\n            <path\n              d=\"m22.4 11.6-.5.5-1-1.1-.5-.5h-.5v.5l-.5.5v.5l.5.5v.5l-.5 1h-1l-.5-1-.5-2.6h-.5l-.5.5h-.5l-.5-1h-1.6l-.5.5H11v-.9l.5-.5h.5l.5-.5h1l.6-.5.5-.5v-.6\"\n              fill=\"none\" stroke=\"currentColor\" />\n            <path\n              d=\"m13.1 8.5-.5-1.1.5-1.6 1.6-.5h1v-.5l-.5-1 .7-1.5m-5.4 5.1.5-.5.5-1.6M7.2 2.8h1.6l.5.5v.5l-1 .5h-1l-.6.5-.5.6v.5l-.5.5-1 .5-1 .5h-1m-1.1 3.8.9 1.4.5.5v1.6l1 1.6 1 .5v.5l-.5 1v1\"\n              fill=\"none\" stroke=\"currentColor\" />\n            <path\n              d=\"M22.4 12c0 5.8-4.6 10.5-10.4 10.5-5.8 0-10.5-4.6-10.5-10.4C1.5 6.3 6.2 1.6 12 1.6h0c5.8 0 10.4 4.6 10.4 10.4h0z\"\n              fill=\"none\" stroke=\"currentColor\" />\n          </svg>\n          <span>\n            <strong class=\"country\" ref=\"site\">{{site}}</strong>\n            <span class=\"text\" v-if=\"text\">\n              {{text}}\n              <svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n                <path d=\"M11.746 15.75L5.75 10.151 7.612 8.37l4.137 3.803 4.043-3.923 1.958 1.894-6.004 5.606\" fill=\"currentColor\" fill-rule=\"evenodd\"/>\n              </svg>\n            </span>\n          </span>\n        </button>\n        <transition name=\"slide-down\">\n          <div class=\"panel\" v-show=\"panel\">\n            <div class=\"container\">\n              <button class=\"close\" @click.prevent=\"togglePanel\"><span>{{labels.closePanel}}</span></button>\n            </div>\n            <h5 v-show=\"$slots.language\">{{site}} <span class=\"language\"><slot name=\"language\" /></span></h5>\n            <div class=\"content\" v-if=\"!$slots.language\">\n              <div class=\"container\">\n                <div class=\"intro-text\" v-if=\"$slots.intro\">\n                  <slot name=\"intro\" />\n                </div>\n                <roche-detected-country :labels=\"labels\"></roche-detected-country>\n                <roche-country-selector :labels=\"labels\" :continents=\"continents\"></roche-country-selector>\n              </div>\n            </div>\n          </div>\n        </transition>\n      </div>",
        props: {
          site: String,
          text: String,
          labels: Object,
          continents: Array,
          isCcav: {
            type: Boolean,
            "default": false
          }
        },
        mixins: [CheckSizeMixin],
        data: function data() {
          return {
            panel: false,
            isMobile: false,
            blocked: false,
            $content: null
          };
        },
        computed: {
          disabled: function disabled() {
            if (this.blocked) return true;
            return !this.continents && !this.isMobile;
          },
          classes: function classes() {
            return {
              open: this.panel,
              disabled: this.disabled,
              'has-panel': this.continents,
              blocked: this.blocked,
              'has-language': this.$slots.language
            };
          }
        },
        methods: {
          togglePanel: function togglePanel() {
            var _this = this;

            if (!this.disabled) {
              this.panel = !this.panel;

              if (this.panel) {
                document.body.classList.add('is-modal-open');
                this.$nextTick(function () {
                  setTimeout(function () {
                    document.addEventListener('click', _this.checkInsideClick);
                  }, 60);
                });
              } else {
                document.body.classList.remove('is-modal-open');
                document.removeEventListener('click', this.checkInsideClick);
              }
            }
          },
          checkIfMobile: function checkIfMobile() {
            var inputActive = this.$content && this.$content.querySelector('input[type="text"]');

            if (this.panel && !inputActive) {
              this.togglePanel();
            }

            this.checkSize();
            var isMobile = this.$refs.site;

            if (isMobile) {
              var display = window.getComputedStyle(isMobile, null).getPropertyValue('display');
              this.isMobile = display === 'none';
            }
          },
          setActiveLink: function setActiveLink() {
            var languageLinks = document.querySelectorAll('.language a');
            var lang = document.documentElement.lang.slice(0, 2);

            _toConsumableArray(languageLinks).forEach(function (link) {
              if (link.innerText.toLowerCase() === lang) {
                link.classList.add('active');
              } else {
                link.classList.remove('active');
              }
            });
          },
          checkIfFormPage: function checkIfFormPage() {
            var _this2 = this;

            this.$nextTick(function () {
              _this2.blocked = !!document.body.classList.contains('form-page');
            });
          },
          setCountryCode: function setCountryCode() {
            var htmlLang = document.documentElement.lang;
            var countryCode = htmlLang.slice(3);
            var isGlobalSite = htmlLang.length === 2; // global: en, fr, it, local site: en-IE

            var geoIp = Cookies.get('geoIp');
            var preselectCountry = Cookies.get('preselectCountry');

            if (this.isCcav && preselectCountry && preselectCountry.length > 0) {
              return this.$store.dispatch('updateCountryCode', preselectCountry);
            }

            if (!geoIp) {
              return this.$store.dispatch('updateCountryCode', 'CH'); // Falback for author, publish envs always have the cookie set
            }

            if (isGlobalSite) {
              return this.$store.dispatch('updateCountryCode', geoIp);
            }

            return this.$store.dispatch('updateCountryCode', countryCode);
          },
          checkInsideClick: function checkInsideClick(e) {
            var _this3 = this;

            if (this.$content) {
              var isClickInside = this.$content.contains(e.target);
              this.$nextTick(function () {
                if (!isClickInside && _this3.panel) {
                  _this3.togglePanel();
                }
              });
            }
          }
        },
        mounted: function mounted() {
          var _this4 = this;

          this.checkIfFormPage();
          this.checkIfMobile();
          this.setActiveLink();
          this.setCountryCode();
          this.$content = this.$el.querySelector('.panel > .content');
          window.addEventListener('resize', this.checkIfMobile);

          if (this.$el.querySelector('.panel h3 a')) {
            this.$el.querySelector('.panel h3 a').addEventListener('click', function (e) {
              e.preventDefault();

              _this4.togglePanel();
            });
          }
        }
      });
    }
  }]);

  return GeoLocalization;
}();

export default GeoLocalization;